module.exports = __webpack_public_path__ + "bbd9e2482cb2fec3f99565d6fc9ffb9b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/py.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/py.svg
// module chunks = 0